export default __webpack_public_path__ + "static/media/team-illustration.cf40d8a0.svg";